import { LoaderCircle } from 'lucide-react'

const Loading = ({ waitingForUpload }: { waitingForUpload: boolean }) => {
  return (
    <div className='flex flex-col items-center justify-center h-screen'>
      <LoaderCircle
        size={48}
        className='text-teal-400 mb-4 animate-spin'
      />
      {waitingForUpload && (
        <p className='text-lg text-gray-700'>
          Processing your request. Please do not close the window.
        </p>
      )}
    </div>
  )
}

export default Loading
